import {HttpAxiosRequest} from "../httpAxiosBase";
import {SolicitationStatusViewDTO} from "../../types/solicitation/solicitationData";
import {BaseResponse} from "../../types/baseEntities";

export const HttpSolicitationOnboarding = {
    getEndpoint: (url: string): string => `onboarding-solicitud${url}`,

    getStatusById: (solicitationId: number) : Promise<SolicitationStatusViewDTO> => {
        return HttpAxiosRequest.get(
            HttpSolicitationOnboarding.getEndpoint( `/${solicitationId}`)
        )
    },
    
    approveGuarantee: (solicitationId: number) : Promise<number> => {
        return HttpAxiosRequest.post(
            HttpSolicitationOnboarding.getEndpoint(`/${solicitationId}/aprobar-operacion`), 
            {}
        )
    },

    rejectGuarantee: (solicitationId: number) : Promise<number> => {
        return HttpAxiosRequest.post(
            HttpSolicitationOnboarding.getEndpoint(`/${solicitationId}/rechazar-operacion`),
            {}
        )
    },
    
    getStepResult: (solicitationId: number, step: number) : Promise<BaseResponse> => {
        return HttpAxiosRequest.get(
            HttpSolicitationOnboarding.getEndpoint(`/${solicitationId}/verificar-paso/${step}`)
        )
    }
}